import React from 'react';
import { Link } from 'react-router-dom';
import { ShellApp } from 'vrlcm-gui-types';
import { shellAppToDisplayName } from 'vrlcm-gui-utils';
import './AppCard.css';

interface Props {
  app: ShellApp;
  absoluteRedirection: boolean;
}

const AppCard: React.FunctionComponent<Props> = ({
  app,
  absoluteRedirection
}) => {
  const linkContent = (
    <>
      <img className="service-card__image" alt="" src={`/assets/${app.icon}`} />
      <span role="heading" aria-level={2} className="service-card__name">
        {shellAppToDisplayName(app)}
      </span>
      <span className="service-card__description">{app.description}</span>{' '}
    </>
  );
  return absoluteRedirection ? (
    <a className="service-card" href={`${app.appUrl}`}>
      {linkContent}
    </a>
  ) : (
    <Link className="service-card" to={`${app.appUrl}`}>
      {linkContent}
    </Link>
  );
};

export default AppCard;
